interface MegaphoneIconProps {
  className?: string;
}

export const MegaphoneIcon = ({ className }: MegaphoneIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_megaphone)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.57143 3.99994H3.42857C1.53503 3.99994 0 5.53497 0 7.42851C0 8.92134 0.954066 10.1913 2.28571 10.662V11.9999C2.28571 13.8935 3.82074 15.4285 5.71429 15.4285H6.28571C6.91689 15.4285 7.42857 14.9169 7.42857 14.2857C7.42857 13.6545 6.91689 13.1428 6.28571 13.1428H5.71429C5.08311 13.1428 4.57143 12.6311 4.57143 11.9999V3.99994Z"
          fill="#FF7472"
        />
        <path
          d="M13.3298 0.907254L4.56695 3.99895V10.8561L13.4204 13.5325C14.6896 13.9026 16.0002 13.0763 16.0002 11.9062V2.50498C16.0002 1.29922 14.6147 0.47023 13.3298 0.907254Z"
          fill="#FFD4D4"
        />
      </g>
      <defs>
        <clipPath id="clip0_megaphone">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
